import { Component } from "react";

// custom markup
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";

import TableCellOfferActions from "../../../services/applications/tables/TableCellOfferActions";
import TableCellApplicationActions from "../../../services/applications/tables/TableCellApplicationActions";

// formaters and other
import _ from "underscore";
import {
  applicationStages,
  applicationEmploymentStatuses,
  applicationLoanPurposes,
} from "admin/shared/dictionary/enums";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import ApplicationDetails from "./ApplicationDetails/Application.Details.Component";
import { assignedApplicationsConnector } from "../../../services/applications/assignerApplications.connector";
import { compose } from "redux";

// icons
import InfoIcon from "@material-ui/icons/InfoOutlined";
import PropTypes from "prop-types";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import { allClaimsOtherThanAml } from "../../../shared/ClaimLists/Claim.Aml.All.List";

export function boolRender(value) {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return "not set";
}

export function dictRender(value, dict) {
  // make sure dict is not undefined
  if (!dict) dict = {};

  let renderValue = dict[value];

  if (!renderValue) {
    renderValue = "not set";
  }

  return renderValue;
}

class ReviewingApplicationsComponent extends Component {
  constructor(props) {
    super(props);

    let columns = this.getCollumns();
    this.state = { columns, isDialogOpen: false, newTaskNum: "" };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (
      props.applicationsTasks.init &&
      props.applications.fetched &&
      !this.props.applicationsTasks.fetched &&
      !this.props.applicationsTasks.fetching
    ) {
      this.props.getApplicationTasks();
    }

    if (
      props.applicationsTasks.init &&
      !this.props.applicationsTasks.others.fetched &&
      !this.props.applicationsTasks.others.fetching
    ) {
      this.props.getOtherUsersTasks();
    }
  }

  handleChange = (event) => {
    this.setState({
      newTaskNum: event.target.value,
    });
  };

  getNewTasks = () => {
    this.props.assignApplicationTasks(Number(this.state.newTaskNum));
    this.setState({ newTaskNum: "" });
  };

  addMoreInfo = (row) => {
    this.props.getRowAdditionalData(
      row.AccountId,
      row.Identity,
      row.DirectDebitAccountId,
      row.Id,
    );
  };

  getDetails = (item, accountInfos) => {
    return <ApplicationDetails item={item} accountInfos={accountInfos} />;
  };

  render() {
    var sortedData = _.sortBy(
      this.props.applicationsTasks.data,
      (application) => {
        return new Date(application.DateSubmitted).valueOf();
      },
    ).reverse();

    return (
      <div className="applications-layout body-height content-padding">
        <h3>My Applications:</h3>

        <div style={{ margin: "20px 0" }}>
          {!this.props.applicationsTasks.others.fetched
            ? Object.keys(this.props.applicationsTasks.others.data).map(
                (userId) => {
                  return (
                    <p key={userId}>
                      user Id: {userId} has:{" "}
                      {this.props.applicationsTasks.others.data[userId].length}{" "}
                      tasks
                    </p>
                  );
                },
              )
            : undefined}
        </div>

        {!this.props.applicationsTasks.fetched ? (
          <div> Loading... </div>
        ) : (
          <div>
            <TextField
              size="small"
              variant="outlined"
              helperText="How many new application do you want?"
              label="Number of Applications to assign"
              style={{ width: "300px", marginRight: "4px" }}
              onChange={this.handleChange}
              value={this.state.newTaskNum}
            />
            <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.getNewTasks}
              >
                Get new tasks
              </Button>
            </ClaimsWrapper>
            <TableNew
              {...this.props}
              columns={this.state.columns}
              tableKey={"Applications-Assingned" + !!this.props.accountId}
              selectId={"Id"}
              items={sortedData}
              showDetailsFun={this.addMoreInfo}
              actionColumnWidth={420}
              detailsRenderer={(item) => {
                return this.getDetails(item, this.props.accountInfos);
              }}
            />
          </div>
        )}
        <br />
        <ClaimsWrapper claimAuth={allClaimsOtherThanAml}>
          <Button
            variant="contained"
            color="primary"
            icon={<InfoIcon />}
            onClick={this.openInfoDialog}
          >
            Information for application status flow
          </Button>
        </ClaimsWrapper>
        <Dialog open={this.state.isDialogOpen} onClose={this.closeInfoDialog}>
          <DialogContent>
            <p>
              <strong>Draft: </strong>next can be Submitted
            </p>
            <p>
              <strong>Submitted: </strong>next can be AwaitingOfferAcceptance or
              FailedAutoReview
            </p>
            <p>
              <strong>AwaitingOfferAcceptance: </strong>passed AutoReview,
              awaiting customer acceptance of offer
            </p>
            <p>
              <strong>AwaitingManualReview: </strong>offer accepted, manual
              review will decide next stage. Next can be AwaitingCompletion (if
              more completions needed), AwaitingOfferAcceptance (if offer
              changed), ManuallyApproved or ManuallyRejected
            </p>
            <p>
              <strong>FailedAutoReview: </strong>manual review will decide next
              stage...
            </p>
            <p>
              <strong>ManuallyApproved: </strong>application life cycle has
              ended, financing is next.
            </p>
            <p>
              <strong>ManuallyRejected: </strong>next can, in theory, be
              AwaitingManualReview (this would be set by some reviewer, sifting
              through manually rejected apps, or by special request)
            </p>
          </DialogContent>
        </Dialog>
      </div>
    );
  }

  openInfoDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  closeInfoDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  getCollumns = () => {
    return [
      {
        key: "AccountId",
        label: "Get ssn",
        visible: true,
        filter: false,
        type: CELL_TYPES.ssn,
      },
      {
        key: "DateSubmitted",
        label: "Submitted",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "AccountId",
        label: "Account Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "Stage",
        label: "Application stage",
        visible: true,
        enumDict: applicationStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "AppliedAmount.Amount",
        label: "Amount",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "AppliedTerm",
        label: "Term",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "LivingCosts.Amount",
        label: "Living costs",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "Income.Amount",
        label: "Income",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "HouseholdAdults",
        label: "Adults in household",
        visible: false,
        type: CELL_TYPES.number,
      },
      {
        key: "HouseholdChildren",
        label: "Children in household",
        visible: false,
        type: CELL_TYPES.number,
      },
      {
        key: "CreditsMonthlyCosts.Amount",
        label: "Monthly credit cost",
        visible: false,
        type: CELL_TYPES.money,
      },
      {
        key: "EmploymentStatus",
        label: "Employment",
        visible: false,
        enumDict: applicationEmploymentStatuses,
        type: CELL_TYPES.enum,
      },
      { key: "EmploymentMonths", label: "Employment months", visible: false },
      {
        key: "CreditPurpose",
        label: "Purpose",
        visible: false,
        enumDict: applicationLoanPurposes,
        type: CELL_TYPES.enum,
      },
      { key: "IsPep", label: "PEP", visible: false },
      {
        key: "DateStarted",
        label: "Started",
        visible: false,
        type: CELL_TYPES.date,
      },
      {
        key: "Id",
        label: "Manual offer",
        visible: false,
        filter: false,
        renderer: (value, item, props) => {
          return (
            <TableCellOfferActions
              setNominalBasedOffer={props.setNominalBasedOffer}
              setRiskBasedOffer={props.setRiskBasedOffer}
              value={value}
              item={item}
            />
          );
        },
      },
      {
        key: "Id",
        label: "Actions",
        visible: true,
        filter: false,
        renderer: (value, item, props) => {
          return (
            <TableCellApplicationActions
              approveApplication={props.approveApplication}
              rejectApplication={props.rejectApplication}
              moveToReview={props.moveToReview}
              dropSingle={props.dropSingle}
              value={value}
              item={item}
              getAccountInfoForId={props.getAccountInfoForId}
              accountInfos={props.accountInfos}
            />
          );
        },
      },
    ];
  };

  static propTypes = {
    getApplicationsForAccount: PropTypes.func,
    getApplications: PropTypes.func,
    getRowAdditionalData: PropTypes.func,
    changeApplicationTaskListPage: PropTypes.func,
    swapApplications: PropTypes.func,
    getAccountInfoForId: PropTypes.func,
    moveToReview: PropTypes.func,
    //
    applicationsTasks: PropTypes.any,
    applications: PropTypes.any,
    accountInfos: PropTypes.any,
    accountId: PropTypes.any,
    //
    changeApplicationTaskListFilter: PropTypes.any,
    approveApplication: PropTypes.any,
    rejectApplication: PropTypes.any,
    setNominalBasedOffer: PropTypes.any,
    setRiskBasedOffer: PropTypes.any,
  };
}

export default compose(assignedApplicationsConnector)(
  ReviewingApplicationsComponent,
);
